<template>
  <div>
    <section class="mail-tips">
      <span style="font-size: 14px; font-weight: bold">温馨提示</span>
      <p style="font-size: 12px">
        如果反馈的是系统问题，请在反馈内容最后注明您的手机型号以帮助我们更好定位问题，谢谢。
      </p>
    </section>
    <div class="weui-cells__title">类型</div>
    <div class="sugs-type">
      <div
        class="type-item"
        :class="{ selected: type == 1 }"
        style="margin-right: 7px"
        @click="choose(1)"
      >
        系统出错
      </div>
      <div
        class="type-item"
        :class="{ selected: type == 2 }"
        style="margin-left: 7px; margin-right: 7px"
        @click="choose(2)"
      >
        优化建议
      </div>
      <div
        class="type-item"
        :class="{ selected: type == 3 }"
        style="margin-left: 7px"
        @click="choose(3)"
      >
        其他
      </div>
    </div>
    <div class="sugs-title">
      <div class="weui-cells__title">标题</div>
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="title"
              type="text"
              placeholder="请输入标题"
            />
          </div>
        </div>
      </div>

      <div class="weui-cells__title">反馈内容</div>
      <div class="weui-cells weui-cells_form">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              v-model="content"
              placeholder="请输入反馈的内容"
              rows="3"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{ content.length }}</span
              >/512
            </div>
          </div>
        </div>
      </div>

      <div class="weui-cells__title">
        图片说明 - 支持 jpg/png/gif
        <span style="color: red">（不能超过4M）</span>
      </div>
      <div class="weui-cells weui-cells_form" id="uploader">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <div class="weui-uploader">
              <div class="weui-uploader__hd">
                <p class="weui-uploader__title">请上传辅助图片</p>
                <div class="weui-uploader__info">
                  <span id="uploadCount">0</span>/3
                </div>
              </div>
              <div class="weui-uploader__bd">
                <ul class="weui-uploader__files" id="uploaderFiles"></ul>
                <div class="weui-uploader__input-box">
                  <input
                    id="uploaderInput"
                    class="weui-uploader__input"
                    type="file"
                    accept="image/*"
                    multiple=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="warehousing-footer-item" style="flex: 2" @click="save">
      <a href="javascript:;">提 交</a>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      type: 0,
      title: "",
      content: "",
      uploadList: [],
      pics: [],
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
  },
  methods: {
    choose(n) {
      this.type = n;
    },
    save() {
      if (this.type == 0) {
        weui.alert("请选择意见反馈类型");
        return;
      } else if (!this.title) {
        weui.alert("标题不能为空");
        return;
      } else if (!this.content) {
        weui.alert("内容不能为空");
        return;
      }

      let picUrls = [];
      for (let i = 0; i < this.pics.length; i++) {
        let picUrl = `${config.xytPreUrl}/sign/${this.pics[i].dateFolder}/${this.pics[i].destFileName}`;
        picUrls.push(picUrl);
      }
      let params = {
        type: this.type,
        title: this.title,
        content: this.content,
        pics: picUrls,
      };

      axios
        .post("/api/suggestion", params)
        .then((res) => {
          if (res.data.success) {
            this.$router.push(
              "/suggestionSuccess/" + res.data.data._id + "/" + this.encodeToken
            );
          } else {
            weui.alert("提交意见反馈报错");
          }
        })
        .catch((err) => {
          weui.alert("提交意见反馈报错");
        });
    },
  },
  mounted() {
    let that = this;
    /* 图片自动上传 */
    var uploadCount = 0;
    var uploadCountDom = document.getElementById("uploadCount");
    weui.uploader("#uploader", {
      url: "/api/upload/uploadFile",
      auto: true,
      type: "file",
      fileVal: "fileVal",
      compress: {
        width: 1600,
        height: 1600,
        quality: 0.8,
      },
      onBeforeQueued: function (files) {
        if (
          ["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(
            this.type
          ) < 0
        ) {
          weui.alert("请上传正确格式的图片");
          return false;
        }
        if (this.size > 4 * 1024 * 1024) {
          weui.alert("请上传不超过4M的图片");
          return false;
        }
        if (files.length > 1) {
          // 防止一下子选中过多文件
          weui.alert("最多只能上传1张图片");
          return false;
        }
        if (uploadCount + 1 > 3) {
          weui.alert("最多只能上传3张图片");
          return false;
        }

        ++uploadCount;
        uploadCountDom.innerHTML = uploadCount;
      },
      onQueued: function () {
        that.uploadList.push(this);
      },
      onBeforeSend: function (data, headers) {
        headers["Authorization"] = "Bearer " + that.token;
        // return false; // 阻止文件上传
      },
      onProgress: function (procent) {},
      onSuccess: function (ret) {
        that.pics.push(ret.data);
      },
      onError: function (err) {
        console.log(err);
      },
    });

    // 缩略图预览
    document
      .querySelector("#uploaderFiles")
      .addEventListener("click", function (e) {
        var target = e.target;

        while (!target.classList.contains("weui-uploader__file") && target) {
          target = target.parentNode;
        }
        if (!target) return;

        var url = target.getAttribute("style") || "";
        var id = target.getAttribute("data-id");

        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
        }
        var gallery = weui.gallery(url, {
          className: "custom-name",
          onDelete: function () {
            weui.confirm("确定删除该图片？", function () {
              --uploadCount;
              uploadCountDom.innerHTML = uploadCount;
              that.studentCardInfo = {};

              for (var i = 0, len = that.uploadList.length; i < len; ++i) {
                var file = that.uploadList[i];
                if (file.id == id) {
                  file.stop();
                  for (let j = 0; j < that.pics.length; j++) {
                    if (that.pics[j].size == file.size) {
                      that.pics.splice(j, 1);
                      break;
                    }
                  }
                  that.uploadList.splice(i, 1);
                  break;
                }
              }
              target.remove();
              gallery.hide();
            });
          },
        });
      });
  },
};
</script>

<style scoped>
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
.sugs-type {
  display: flex;
  margin-left: 15px;
  margin-right: 15px;
}
.type-item {
  flex: 1;
  text-align: center;
  border: 1px solid #eee;
  padding: 10px;
  font-size: 16px;
}
.type-item.selected {
  color: orangered;
  border: 1px solid orangered;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/Suggestion.vue